// extracted by mini-css-extract-plugin
export default {"title":"Code_title__aGTlL","description":"Code_description__oM2a2"};